import { render } from "./setModulePrice1.vue?vue&type=template&id=6f573fe8&scoped=true"
import script from "./setModulePrice1.vue?vue&type=script&lang=js"
export * from "./setModulePrice1.vue?vue&type=script&lang=js"

import "./setModulePrice1.vue?vue&type=style&index=0&id=6f573fe8&scoped=true&lang=css"

import exportComponent from "D:\\Project\\website-shuziyun\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f573fe8"]])

export default __exports__